import { useQuery } from '@tanstack/react-query';
import { walletService } from '../services/wallet.service';

export function useWalletBalance() {
  return useQuery({
    queryKey: ['walletBalance'],
    queryFn: () => walletService.getBalance(),
  });
}
